import icons from '@web-packages/icons';
import Skeleton from '@mui/material/Skeleton';
import ButtonMUI from '@mui/material/Button';
import LoadingButtonMUI, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import SvgIcon from '@mui/material/SvgIcon';
import Badge from '../Badge';
import { buttonStyle, noPaddingStyle } from './styled';

import { ButtonProps } from './types';

const findLoadingPosition = (startIcon? : typeof SvgIcon | null, endIcon?: typeof SvgIcon | null): 'start' | 'end' | undefined => {
  if (endIcon) return 'end';
  if (startIcon) return 'start';

  return undefined;
};

const Button = ({
  id,
  label,
  color = 'primary',
  type,

  onClick,

  disabled,
  isLoadingScene,
  showSkeleton,
  badgeNumber,

  startIconName,
  endIconName,
  variant,
  children,
  shape = 'round',
  isSmall = false,
  ignoreDisabledColor = false,
  preventPadding = false,
  fullWidthOnMobile = true,
}: ButtonProps & { fullWidthOnMobile?: boolean }) => {
  if (showSkeleton) {
    return (
      <Skeleton sx={{ height: 60 }}>
        <ButtonMUI
          sx={{
            padding: '14px 24px',
          }}
        >
          Lorem ipsum
        </ButtonMUI>
      </Skeleton>
    );
  }
  const StartIcon = startIconName ? icons[startIconName] : null;
  const EndIcon = endIconName ? icons[endIconName] : null;

  const isLoadingButton = isLoadingScene !== null && (!StartIcon || !EndIcon);

  const loadingPosition = isLoadingButton ? findLoadingPosition(StartIcon, EndIcon) : undefined;
  const preventBtnPadding = preventPadding && variant === 'text';

  const props: LoadingButtonProps = {
    type,
    color,
    variant,
    onClick,
    disabled,
    id: id || 'gtm-round-button',
    // title: label,
    loading: (isLoadingScene || undefined),
    startIcon: StartIcon ? <StartIcon /> : null,
    endIcon: EndIcon ? <EndIcon /> : null,
  };
  return (
    <Badge
      badgeNumber={(showSkeleton || disabled) ? 0 : badgeNumber}
      marginTop={7}
      marginRight={8}
      fullWidthOnMobile={fullWidthOnMobile}
    >
      {
        isLoadingButton
          ? (
            <LoadingButtonMUI
              {...props}
              loadingPosition={loadingPosition}
              disableRipple={preventBtnPadding}
              sx={{
                ...buttonStyle(isSmall, shape, color, ignoreDisabledColor),
                ...noPaddingStyle(preventBtnPadding, color, variant),
                width: {
                  xs: '100%',
                  sm: 'auto',
                  md: 'auto',
                }
              }}
            >
              {label || children}
            </LoadingButtonMUI>
          )
          : (
            <ButtonMUI
              {...props}
              disableRipple={preventBtnPadding}
              sx={{
                ...buttonStyle(isSmall, shape, color, ignoreDisabledColor),
                ...noPaddingStyle(preventBtnPadding, color, variant),
                width: {
                  xs: '100%',
                  sm: '100%',
                  md: 'auto',
                },
              }}
            >
              {label || children}
            </ButtonMUI>
          )
      }
    </Badge>
  );
};

export default Button;
